import ua from './ua'
import ru from './ru'
import en from './en'
import rom from './rom'

export const fallbacks = true
export const translations = { ua, ru, en, rom }
export const locale = 'ua'
